import { useAnalyticsStore } from '../store/analyticsStore';
import { invalidatePromptAnalyticsCache } from '../components/Prompts/promptsV2Api';
import { SKIPSCREEN_ANALYTICS_UPDATED_EVENT } from './realtimeEvents';

/** Refetch candidate analytics snapshot and invalidate prompt engagement cache. */
export async function refreshCandidateAnalyticsRealtime(): Promise<void> {
  invalidatePromptAnalyticsCache();
  try {
    await useAnalyticsStore.getState().fetchCandidateAnalytics({ force: true });
  } catch {
    /* pages may surface errors on next explicit load */
  }
  window.dispatchEvent(new Event(SKIPSCREEN_ANALYTICS_UPDATED_EVENT));
}
